import { useState, useEffect } from "react";
import { LargeSpinner } from "components/Loading";
import "./WrapupPage.css";
import { WrapupWrapper } from "pages/wrapup/WrapupPage";

export default function WrapupStatsPage() {
  const [stats, setStats] = useState<string | null>(null);

  useEffect(() => {
    const fetchWrapupStats = async () => {
      const res = await fetch(`/static/posthunt-state/spicy_stats.txt`);
      const text = await res.text();
      setStats(text);
    };
    fetchWrapupStats().catch(console.error);
  }, []);

  return (
    <WrapupWrapper>
      <h1>Appendix: Statistics</h1>
      {stats ? (
        <div
          className="wrapup-stats"
          dangerouslySetInnerHTML={{ __html: stats }}
        />
      ) : (
        <div style={{ textAlign: "center" }}>
          <LargeSpinner inline />
          Loading data. This might take a while.
        </div>
      )}
    </WrapupWrapper>
  );
}
